import(/* webpackMode: "eager" */ "/workspace/apps/hen-site/src/app/[tenant]/[[...uri]]/error.tsx");
